/**
 * 树形选择组件demo
 * @description 树形选择组件demo
 * @author mll
 * @date 2020-2-19
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '../../../tool'
let { WizContainer } = framework_tool;
let { WizTreeSelectList } = component_tool;

class TreeSelectList extends WizContainer {

    componentName = 'TreeSelectListDemo';

    _render() {
        let treeData = [
            {
                title: '0-0',
                key: '0-0',
                children: [
                    {
                        title: '啊圣诞节卡是贷记卡圣诞节卡是贷记卡手机壳啊圣诞节卡是贷记卡圣诞节卡是贷记卡手机壳',
                        key: '0-0-0',
                        children: [
                            { title: '啊圣诞节卡是贷记卡圣诞节卡是贷记卡手机壳啊圣诞节卡是贷记卡圣诞节卡是贷记卡手机壳啊圣诞节卡是贷记卡圣诞节卡是贷记卡手机壳', key: '0-0-0-0' },
                            { title: '0-0-0-1', key: '0-0-0-1' },
                            { title: '0-0-0-2', key: '0-0-0-2' },
                        ],
                    },
                    {
                        title: '0-0-1',
                        key: '0-0-1',
                        children: [
                            { title: '0-0-1-0', key: '0-0-1-0' },
                            { title: '0-0-1-1', key: '0-0-1-1' },
                            { title: '0-0-1-2', key: '0-0-1-2' },
                        ],
                    },
                    {
                        title: '0-0-2',
                        key: '0-0-2',
                    },
                ],
            },
            {
                title: '0-1',
                key: '0-1',
                children: [
                    { title: '0-1-0-0', key: '1' },
                    { title: '0-1-0-1', key: '2' },
                    { title: '0-1-0-2', key: '3' },
                ],
            },
            {
                title: '0-2',
                key: '0-2',
            },
        ]
        return (
            <div style={{ height: 800, width: 800 }}>
                <WizTreeSelectList
                        treeProps={{checkStrictly:true}}
                    treeData={treeData}
                    autoExpand={true}
                    checkedKeys={[
                         '1' ,
                         '2' ,
                         '3',
                     ]}
                     listCheck={[
                        { title: '0-1-0-0', key: '1' },
                        { title: '0-1-0-1', key: '2' },
                        { title: '0-1-0-2', key: '3' },
                    ]}
                    itemProps={{
                    icon: 'unordered-list',
                    title: '课程分类',
                    tips: '请勾选所属课程分类'
                }}
                onChange={(selects) => {
                    log.info('已选数据：', selects)
                    log.info('全部数据', treeData)
                }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(TreeSelectList);
